import { memo, FC } from 'react';
import { Backdrop, Box, CircularProgress, Typography } from '@mui/material';

const Loader: FC<any> = ({
  alignment = 'center',
  background = 'white',
  position = 'relative',
  LoadingMessage = '',
  direction = 'row',
}) => {
  return (
    <Backdrop
      open={Boolean(true)}
      sx={{
        background,
        zIndex: theme => theme.zIndex.drawer + 1,
        position,
        justifyContent: alignment,
        flexDirection: direction,
      }}
    >
      <CircularProgress />
      {LoadingMessage && (
        <Box>
          <Typography variant='h3'> {LoadingMessage}</Typography>
        </Box>
      )}
    </Backdrop>
  );
};


export default memo(Loader);
